type ConfigType = {
	[key: string]: string;
};
export const config: ConfigType = {
	FL_Fluvial_Official: "AD",
	"FL_Fluvial_Official.FF Code (Official)": "AE",
	"FL_Fluvial_Official.FF Frequency (Official)": "AF",
	"FL_Fluvial_Official.FF Protection (Official)": "AG",
	"FL_Fluvial_Official.FF Return Period (Official)": "AH",
	"FL_Fluvial_Official.FF Schema (Official)": "AI",
	"FL_Fluvial_Official.intensity": "AJ",
	FL_Fluvial_SwissRe: "AK",
	"FL_Fluvial_SwissRe.FF Code (SR)": "AL",
	"FL_Fluvial_SwissRe.FF Frequency (SR)": "AM",
	"FL_Fluvial_SwissRe.FF Protection (SR)": "AN",
	"FL_Fluvial_SwissRe.FF Return Period (SR)": "AO",
	"FL_Fluvial_SwissRe.FF Schema (SR)": "AP",
	"FL_Fluvial_SwissRe.intensity": "AQ",
	FL_Surge_SwissRe: "AR",
	"FL_Surge_SwissRe.Surge Return Period": "AS",
	"FL_Surge_SwissRe.intensity": "AT",
	FL_Pluvial_SwissRe: "AU",
	"FL_Pluvial_SwissRe.PF Return Period (SR)": "AV",
	"FL_Pluvial_SwissRe.PF Risk Level (SR)": "AW",
	"FL_Pluvial_SwissRe.intensity": "AX",
	EQ_LocalSoilCondition_Global_SwissRe: "AY",
	"EQ_LocalSoilCondition_Global_SwissRe.EQ Hazard": "AZ",
	"EQ_LocalSoilCondition_Global_SwissRe.EQ MMI": "BA",
	"EQ_LocalSoilCondition_Global_SwissRe.EQ PGA [g]": "BB",
	"EQ_LocalSoilCondition_Global_SwissRe.intensity": "BC",
	EQ_Bedrock_Global_SwissRe: "BD",
	"EQ_Bedrock_Global_SwissRe.EQ Hazard": "BE",
	"EQ_Bedrock_Global_SwissRe.EQ MMI": "BF",
	"EQ_Bedrock_Global_SwissRe.EQ PGA [g]": "BG",
    "EQ_Bedrock_Global_SwissRe.intensity": "BH",
    EQ_Tsunami_SwissRe: "BI",
    "EQ_Tsunami_SwissRe.Wave Height (m)": "BJ",
    "EQ_Tsunami_SwissRe.intensity": "BK",
    WS_Windspeed_Global_SwissRe: "BL",
    "WS_Windspeed_Global_SwissRe.Storm Hazard": "BM",
    "WS_Windspeed_Global_SwissRe.Storm Peak Gust [m/s]": "BN",
    "WS_Windspeed_Global_SwissRe.intensity": "BO",
    "CS_Hail_Global_SwissRe": "BP",
    "CS_Hail_Global_SwissRe.Hail Days (>2.5cm) per Year": "BQ",
    "CS_Hail_Global_SwissRe.Hail Hazard (current climate)": "BR",
    "CS_Hail_Global_SwissRe.31-set.Hail Hazard": "BS",
    "CS_Hail_Global_SwissRe.31-set.Hail Days (31-year-average)": "BT",
    "CS_Hail_Global_SwissRe.31-set.Hail Days (31 year-average)": "BT",
    "CS_Hail_Global_SwissRe.31-set.31-year trend": "BU",
    "CS_Hail_Global_SwissRe.31-set.Mean Hail Probability (31-year data)": "BV",
    "CS_Hail_Global_SwissRe.64-set.Hail Hazard": "BW",
    "CS_Hail_Global_SwissRe.64-set.Hail Days (64 year-average)": "BX",
    "CS_Hail_Global_SwissRe.64-set.Hail Days (64-year-average)": "BX",
    "CS_Hail_Global_SwissRe.64-set.64-year trend": "BY",
    "CS_Hail_Global_SwissRe.64-set.Mean Hail Probability (64-year data)": "BZ",
    "CS_Hail_Global_SwissRe.intensity": "CA",
    "CS_Tornado_Global_SwissRe": "CB",
    "CS_Tornado_Global_SwissRe.Tornado Hazard": "CC",
    "CS_Tornado_Global_SwissRe.Tornadoes per year": "CD",
    "CS_Tornado_Global_SwissRe.30-year trend": "CE",
    "CS_Tornado_Global_SwissRe.intensity": "CF",
    "EQ_Landslide_Global_SwissRe": "CG",
    "EQ_Landslide_Global_SwissRe.Landslide Hazard": "CH",
    "EQ_Landslide_Global_SwissRe.intensity": "CI",
    "WF_Wildfire_Global_SwissRe": "CJ",
    "WF_Wildfire_Global_SwissRe.Wildfire Hazard": "CK",
    "WF_Wildfire_Global_SwissRe.Wildfire Susceptibility": "CL",
    "WF_Wildfire_Global_SwissRe.intensity": "CM",
    "CS_Lightning_Global_SwissRe": "CN",
    "CS_Lightning_Global_SwissRe.Lightning Hazard": "CO",
    "CS_Lightning_Global_SwissRe.Lightning Annual Flash Rate/km²": "CP",
    "CS_Lightning_Global_SwissRe.intensity": "CQ",
    "VO_AshThickness_Global_SwissRe": "CR",
    "VO_AshThickness_Global_SwissRe.Volcano Hazard": "CS",
    "VO_AshThickness_Global_SwissRe.Volcano Ash Thickness [cm]": "CT",
    "VO_AshThickness_Global_SwissRe.intensity": "CU",
    "WF_DistToBush_AUS_SwissRe": "CV",
    "WF_DistToBush_AUS_SwissRe.Australia: Distance to Bush": "CW",
    "WF_DistToBush_AUS_SwissRe.Distance to Bush (m)": "CX",
    "DR_Subsidence_France_SwissRe": "CY",
    "DR_Subsidence_France_SwissRe.Subsidence Hazard": "CZ",
};
